var _circle, _circle2, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _ellipse2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _ellipse4, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _ellipse5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvnishOnMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 748,
    height: 1061,
    viewBox: "0 0 748 1061",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 373.905,
    cy: 686.905,
    r: 373.905,
    fill: "#F0C420"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.905,
    cy: 686.905,
    r: 373.905,
    fill: "url(#paint0_linear_311_44)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.806,
    cy: 445.453,
    rx: 112.5,
    ry: 31.5,
    transform: "rotate(-38.306 177.806 445.453)",
    fill: "#F0C420"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.451 465.554C220.579 470.561 226.344 474.707 226.344 479.366",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.666 479.366C202.666 485.943 202.666 492.521 202.666 499.098",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.122 499.098C169.122 505.244 167.526 518.298 175.042 520.803",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.417 514.883C147.417 522.776 147.417 530.669 147.417 538.561",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.793 524.749C118.243 534.244 115.846 544.811 115.846 554.347",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.222 528.695C88.222 538.096 86.522 545.361 84.2756 554.347",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.237 451.742C239.536 458.525 243.657 460.939 248.049 467.527",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247 441C250.66 442.463 264.366 450.194 266 456",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M263.834 424.117C275 429 272.704 433.983 281.593 433.983",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M271.727 400.439C276.236 402.199 280.635 404.386 285.539 404.386",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M271.727 388.6C273.86 388.6 281.213 389.213 283.5 391.5C285.748 393.748 292.057 392.846 295.405 394.52",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.248,
    cy: 864.742,
    rx: 112.5,
    ry: 31.5,
    transform: "rotate(-128.353 142.248 864.742)",
    fill: "#F0C420"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.316 824.08C167.321 821.948 171.463 816.18 176.122 816.176",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.141 839.854C182.718 839.849 189.296 839.843 195.873 839.838",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.9 873.382C202.046 873.377 215.101 874.962 217.6 867.445",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.703 895.074C219.596 895.068 227.489 895.061 235.381 895.055",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M221.592 922.69C231.088 924.233 241.656 926.62 251.192 926.613",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.564 954.258C234.964 954.25 242.231 955.944 251.218 958.183",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.491 808.306C155.27 803.001 157.681 798.878 164.265 794.481",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.739 795.551C139.199 791.891 146.919 778.178 152.723 776.539",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.843 778.731C125.716 767.561 130.701 769.853 130.694 760.964",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1581 770.857C98.9141 766.347 101.097 761.946 101.093 757.042",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.319 770.867C85.3173 768.734 85.9236 761.381 88.2092 759.092C90.4553 756.842 89.5478 750.534 91.2193 747.184",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.269,
    cy: 448.555,
    rx: 112.5,
    ry: 31.5,
    transform: "rotate(44.6643 578.269 448.555)",
    fill: "#F0C420"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M563.293 491.355C558.585 494.08 555.175 500.308 550.551 500.879",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M547.653 477.379C541.125 478.184 534.597 478.989 528.07 479.793",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M523.964 446.502C517.865 447.254 504.714 447.267 503.147 455.033",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M505.641 426.892C497.808 427.858 489.975 428.824 482.141 429.79",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M492.469 400.683C482.855 400.306 472.075 399.221 462.611 400.388",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M484.689 369.832C475.359 370.982 467.94 370.184 458.747 369.055",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M578.934 505.331C572.85 511.421 570.958 515.806 564.957 520.972",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M591.157 516.684C590.153 520.495 584.157 535.044 578.595 537.377",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M609.973 531.326C606.493 543.005 601.266 541.336 602.354 550.158",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M634.439 536.261C633.244 540.952 631.612 545.585 632.212 550.453",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M646.189 534.812C646.45 536.929 646.742 544.301 644.752 546.852C642.796 549.358 644.463 555.509 643.211 559.037",
    stroke: "#F0C420",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.056,
    cy: 871.309,
    rx: 112.5,
    ry: 31.5,
    transform: "rotate(130.12 609.056 871.309)",
    fill: "#DDAF03"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M565.203 859.771C562.114 855.293 555.635 852.388 554.7 847.823",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M577.897 843.073C576.577 836.629 575.258 830.186 573.938 823.742",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M606.8 817.012C605.567 810.991 604.511 797.883 596.646 796.936",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M624.896 797.193C623.313 789.461 621.729 781.729 620.146 773.996",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M649.98 781.986C649.594 772.372 649.821 761.54 647.908 752.198",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M680.117 771.786C678.231 762.576 678.439 755.117 678.837 745.864",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M552.51 876.469C545.958 870.887 541.436 869.349 535.812 863.776",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M542.162 889.553C538.283 888.855 523.304 884.03 520.538 878.67",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M529.057 909.47C517.138 906.927 518.388 901.584 509.68 903.368",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M526.075 934.25C521.304 933.431 516.556 932.171 511.752 933.155",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M528.45 945.849C526.36 946.277 519.035 947.152 516.335 945.37C513.682 943.619 507.682 945.768 504.066 944.8",
    stroke: "#D3A700",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M325.5 53.5V73.5L337.5 61V65V77.5V85.5L351 90L361.5 94.5L375 97.5L391.5 101.5L401.5 94.5L408.5 81.5L413 65L417.5 46.5L413 29.5L401.5 16L391.5 5L377.5 0H361.5L343.5 5L332 16L322 29.5V46.5L325.5 53.5Z",
    fill: "#242024"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M327 86V71.5L337 58.5V71.5V82.5L347.5 89.5L364 96L347.5 99.5L337 107V99.5H332.5L327 86Z",
    fill: "#A1665E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 118.5L334 110L353 97.5H368L393.5 101.5L400 113.5L406.5 115H416L424 123.5L436.5 126.5L456.5 137L468.5 155.5L474.5 172V201L478 233L474.5 264L468.5 280.5L456.5 290L457.177 273L454 299L461 322.5L447 337.5L425.5 353.5L397 366H368H342L315.5 360L299.5 344.5L295 311L294.167 301.5H278.5L263 290L257 241.5V186L267.5 147L328.5 118.5Z",
    fill: "#006400"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 118.5L334 110L353 97.5H368L393.5 101.5L400 113.5L406.5 115H416L424 123.5L436.5 126.5L456.5 137L468.5 155.5L474.5 172V201L478 233L474.5 264L468.5 280.5L456.5 290L457.177 273L454 299L461 322.5L447 337.5L425.5 353.5L397 366H368H342L315.5 360L299.5 344.5L295 311L294.167 301.5H278.5L263 290L257 241.5V186L267.5 147L328.5 118.5Z",
    fill: "url(#paint1_linear_311_44)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M233 263.5L264 282L279 298H296.5V324L300.5 347.5L316.5 356L335.5 363.5H365.5L394.5 367L417.5 356L433 347.5L447.5 336L459.5 324L454.5 298L459.5 288L474.5 272.5L483.5 263.5L496 260H511.5L523.5 269L529.5 288V306.5L523.5 324L511.5 336L489 356L471 378V387.5L465 398.5L454.5 403.5H300.5L283.5 387.5L258.5 371.5L252 363.5L224 343.5L206 324L200 306.5L205.5 272L233 263.5Z",
    fill: "#002852"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M233 263.5L264 282L279 298H296.5V324L300.5 347.5L316.5 356L335.5 363.5H365.5L394.5 367L417.5 356L433 347.5L447.5 336L459.5 324L454.5 298L459.5 288L474.5 272.5L483.5 263.5L496 260H511.5L523.5 269L529.5 288V306.5L523.5 324L511.5 336L489 356L471 378V387.5L465 398.5L454.5 403.5H300.5L283.5 387.5L258.5 371.5L252 363.5L224 343.5L206 324L200 306.5L205.5 272L233 263.5Z",
    fill: "url(#paint2_linear_311_44)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.054,
    cy: 638.688,
    rx: 112.5,
    ry: 99.0591,
    transform: "rotate(0.321174 365.054 638.688)",
    fill: "#F0C420"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_44",
    x1: 102,
    y1: 313,
    x2: 573.5,
    y2: 1061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#FEFCD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#FEFCD7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_311_44",
    x1: 367.5,
    y1: 97.5,
    x2: 367.5,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EE90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90EE90",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_311_44",
    x1: 364.75,
    y1: 260,
    x2: 364.75,
    y2: 403.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A7A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvnishOnMoon);
export default __webpack_public_path__ + "static/media/avnish-on-moon.d4beb59a04ab2465e36d9ddbdd31e5fe.svg";
export { ForwardRef as ReactComponent };